export const INCHES_PER_YARD = 1944;
export const TIES_UNIT_PRICE = 2;
export const FOAM_COST = 0.797;
export const MARKUP_RATE = 2.5;

export const FORGOT_PASSWORD_LINK = "";
